import { createReducer, on } from "@ngrx/store";
import { loadPortalSettings, loadPortalSettingsFailed, loadPortalSettingsSuccess, disablePortalPage, activatePortalPage } from "../actions/portal.actions";
import { portalInitialState } from "../initial-states/portal.state";
import { IPortalNavigationNodes } from "src/app/models/portal.model";


export const PortalReducer = createReducer(portalInitialState,

	// The reducer runs when a dispatch 'loadPortalSettings' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadPortalSettings,
		(state) => ({
			...state, loading: true
		}),
	),

	// The reducer runs when a dispatch 'loadPortalSettingsSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the portal settings to the store
	on(loadPortalSettingsSuccess,
		(state, { portalSettings }) => ({
			...state, loading: false, loadedOnce:true, value: { ...state.value, settings: portalSettings }
		}),
	),

	// The reducer runs when a dispatch 'loadPortalSettingsFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadPortalSettingsFailed,
		(_, { error }) => ({
			...portalInitialState, loading: false, loadedOnce: true, error
		}),
	),

	// The reducer runs when a dispatch 'disablePage' was triggered
	on(disablePortalPage,
		(state, { pageTitle }) => ({
			...portalInitialState, value: { ...state.value, settings: {...state.value.settings, navigation: { ...state.value.settings.navigation, sidebarnavigation: disablePageByPageTitle(state.value.settings.navigation.sidebarnavigation, pageTitle) }}}
		}),
	),

	// The reducer runs when a dispatch 'activatePortalPage' was triggered
	on(activatePortalPage,
		(state, { pageTitle }) => ({
			...portalInitialState, value: { ...state.value, settings: {...state.value.settings, navigation: { ...state.value.settings.navigation, sidebarnavigation: activatePageByPageTitle(state.value.settings.navigation.sidebarnavigation, pageTitle) }}}
		}),
	),

)

function disablePageByPageTitle(pages: IPortalNavigationNodes[], pageTitle: string) {
	let pageToDisable = pages.find(x => x.title === pageTitle)
	if(!pageToDisable){
		for(const page of pages){
			const childs = page.sections?.flatMap(s => s.childs)
			if(childs){
				pageToDisable = childs.find(x => x.title === pageTitle)
				if(pageToDisable){
					break;
				}
			}
		}
	}

	if(pageToDisable){
		pageToDisable.isDisabled = true
	}
	return pages
}

function activatePageByPageTitle(pages: IPortalNavigationNodes[], pageTitle: string) {
	let pageToDisable = pages.find(x => x.title === pageTitle)
	if(!pageToDisable){
		for(const page of pages){
			const childs = page.sections?.flatMap(s => s.childs)
			if(childs){
				pageToDisable = childs.find(x => x.title === pageTitle)
				if(pageToDisable){
					break;
				}
			}
		}
	}

	if(pageToDisable){
		pageToDisable.isDisabled = false
	}
	return pages
}
